import React from 'react';
import Generation from 'components/Tvendo/Inventory/Operations/TakingInventory/PDFSharedFile';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <Generation
      title="toma de inventario"
      excelName="tomaInventario"
      type="GN" // GN = Generar pdf
      entity="logi/inventory"
      permissions={{
        store: ConstantPermissions.LOGI_INVENTORIES_STORE,
        show: ConstantPermissions.LOGI_INVENTORIES_SHOW,
        delete: ConstantPermissions.LOGI_INVENTORIES_DELETED
      }}
    />
  );
}
